module Omni.Booker {
    NgModule.component("omniBookerExplore", {
        bindings: {
            propertyDetail: "<"
        },
        controller: class OmniBookerExploreController {
            private exploreData; // Data from API for explore data
            private showPropertyLink: boolean;
            private showSpinner: boolean = false;
            private showExploreList: boolean = false;

            // Bindings
            private propertyDetail: PropertyDetail;// This is set from the bindings attribute of this component, it's set externally
            
            static $inject = [
                "omni.bookingapiservice",
                "$window",
                "omni.bookingservice",
                "bookerConfig"
            ];
            constructor(
                private readonly bookingApiService: IBookingApiService,
                private readonly $window: ng.IWindowService,
                private readonly bookingService: IBookingService,
                private readonly bookerConfig: Constants.IBookerConfiguration
            ) {
                this.showPropertyLink = this.bookerConfig.IsBrandPage();
            }
            
            $onChanges() {
                if (this.propertyDetail) {
                    this.getExploreData();
                }
            }

            private exploreProperty(propertyUrl) {
                this.$window.location.href = propertyUrl;
            }

            private getExploreData() {
                this.showExploreList = false;
                this.showSpinner = true;
                this.exploreData = undefined;
                if (this.propertyDetail.HotelId && this.propertyDetail.HotelId.length > 0) {
                    this.bookingApiService.GetExploreData(this.propertyDetail.HotelId)
                        .then((data) => {
                            this.exploreData = data;
                            this.showExploreList = this.exploreData.length > 1;
                        })
                        .finally(() => {
                            this.showSpinner = false;
                        });
                }
            }
        },
        templateUrl: "omni-booker-explore.html"
    });
}
